import initTrackingEvents from "../../tracking/trackingEvents";

export default class Mediathek {
    init() {
        initTrackingEvents();
        return this
    }
}